var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNotes(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6602 11.19L20.6802 15.37C19.8402 18.98 18.1802 20.44 15.0602 20.14C14.5602 20.1 14.0202 20.01 13.4402 19.87L11.7602 19.47C7.59018 18.48 6.30018 16.42 7.28018 12.24L8.26018 8.05001C8.46018 7.20001 8.70018 6.46001 9.00018 5.85001C10.1702 3.43001 12.1602 2.78001 15.5002 3.57001L17.1702 3.96001C21.3602 4.94001 22.6402 7.01001 21.6602 11.19Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0603 20.1401C14.4403 20.5601 13.6603 20.9101 12.7103 21.2201L11.1303 21.7401C7.16034 23.0201 5.07034 21.9501 3.78034 17.9801L2.50034 14.0301C1.22034 10.0601 2.28034 7.9601 6.25034 6.6801L7.83034 6.1601C8.24034 6.0301 8.63034 5.9201 9.00034 5.8501C8.70034 6.4601 8.46034 7.2001 8.26034 8.0501L7.28034 12.2401C6.30034 16.4201 7.59034 18.4801 11.7603 19.4701L13.4403 19.8701C14.0203 20.0101 14.5603 20.1001 15.0603 20.1401Z",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6396 9.27979L17.4896 10.5098",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6602 13.1499L14.5602 13.8899",
    stroke: "#1E729F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotes);
export default __webpack_public_path__ + "static/media/iconNotes.a80d4d347389f09cf281193aea607bd0.svg";
export { ForwardRef as ReactComponent };